/** Shared sim clock helpers. */

export const DEFAULT_MAX_DT = 0.05;

export function clampSimDt(dt: number, maxDt = DEFAULT_MAX_DT): number {
  if (!(dt > 0)) return 0;
  return Math.min(dt, maxDt);
}

export type SystemFn<W> = (world: W, dt: number) => void;

/** Thin system list runner (no archetype registry). */
export function runSystems<W>(
  systems: readonly SystemFn<W>[],
  world: W,
  dt: number,
): void {
  const step = clampSimDt(dt);
  for (let i = 0; i < systems.length; i++) {
    systems[i]!(world, step);
  }
}
